import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

const box = css`
  padding: 20px;
  border-radius: 5px;
  display: flex;
  gap: 15px;
  overflow: hidden;
  border: none;
  background-color: ${colors.white};
  border-color: ${colors.gray.light};
  max-width: 550px;
`;

const counter = css`
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.regular};
  color: ${colors.gray.default};
`;

const backBtn = css`
  margin-right: 15px;
`;

const closeBtn = css`
  right: 30px;
  position: absolute;
`;

export default {
  box,
  counter,
  backBtn,
  closeBtn,
};
